module.exports = __webpack_public_path__ + "img/airsynth.e080f67e.png";